import { useQuery, gql } from '@apollo/client';

import { useAppDispatch } from '../../app/hooks';
import { showErrorSnackbar } from '../snackbar/snackbarSlice';
import { setPortalColor } from './portalSlice';

export const portalReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'UPDATEVIDEOS':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'UPDATETEXT':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    default:
      throw new Error();
  }
};

// Only primaryColor is ever read from this in DashboardOutlet/InPerson - the full portal object
// (incl. media) is fetched separately by useProjectSettingsQuery for the settings editor. Dispatching
// only setPortalColor (a targeted update) instead of a full setPortal replace matters here: DashboardOutlet
// also wraps the settings editor route, so a full replace from this lighter query could race with and
// clobber the full portal fetch that createProject/Portal.tsx depends on.
export const usePortalColorQuery = (id: string, project: string) => {
  const dispatch = useAppDispatch();

  return useQuery(GETPORTALCOLOR, {
    skip: id === project,
    fetchPolicy: 'cache-first',
    variables: { filter: { project: id } },
    onCompleted: (data) => {
      dispatch(setPortalColor(data.portalOne.primaryColor));
    },
    onError: (err) => {
      dispatch(showErrorSnackbar(err.message));
    },
  });
};

const GETPORTALCOLOR = gql`
  query portalOne($filter: FilterFindOnePortalInput) {
    portalOne(filter: $filter) {
      _id
      primaryColor
    }
  }
`;
